<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-0.5,802.5v-4.09c-0.94-0.17-1.77-0.53-2.49-1.04l0.02,0.01l-2.19,2.19l-1.41-1.41l2.18-2.18c-0.5-0.7-0.86-1.53-1.02-2.44
	l-0.01-0.04H-9.5v-2h4.09c0.16-0.94,0.53-1.77,1.04-2.49l-0.01,0.02l-2.19-2.19l1.41-1.41l2.18,2.18c0.7-0.5,1.53-0.86,2.44-1.02
	l0.04,0v-4.09h2v4.09c0.94,0.17,1.77,0.53,2.49,1.04l-0.02-0.01l2.19-2.19l1.41,1.41l-2.18,2.18c0.5,0.7,0.86,1.53,1.02,2.44
	l0.01,0.04h4.09v2H6.41c-0.16,0.94-0.53,1.77-1.04,2.49l0.01-0.02l2.19,2.19l-1.41,1.41l-2.18-2.18c-0.7,0.5-1.53,0.86-2.44,1.02
	l-0.04,0v4.09H-0.5z M-1.62,796.04l2.12-2.12l2.12,2.12l1.41-1.41l-2.12-2.12l2.12-2.12l-1.41-1.41l-2.12,2.12l-2.12-2.12
	l-1.41,1.41l2.12,2.12l-2.12,2.12L-1.62,796.04z"/>
</svg>

</template>